<template>
  <ItemPage
    title="Matérias"
    size="md"
    :actions="actions"
  >
    <template
      v-if="subjectsView"
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquise pelo nome ou abreviatura"
        single-line
        hide-details
      />
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            :search="search"
            item-key="id"
            @click:row="editSubject($event)"
          >
            <!-- <template v-slot:item.enabled="{ item }">
              {{ item.enabled }}
            </template> -->
          </v-data-table>
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import GenericFormDialog from '@/components/settings/GenericFormDialog.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      subjectsView: false,
      subjectsCreate: false,
      loading: false,
      loadingMsg: '',
      request: false,
      dialogAddSubject: false,
      renderComponent: 0,
      contents: [],
      snackbar: false,
      msgSnackbar: '',
      timeout: 3000,
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'enabled'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar matéria',
          action: this.openGenericFormDialog,
          icon: 'mdi-plus',
          disabled: !this.subjectsCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.getSubject()
      this.subjectsView = utils.checkPermissions('subjects.view-any')
      this.subjectsCreate = utils.checkPermissions('subjects.create')
    },
    async getSubject () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getSubjects()
        this.contents = content
        this.contents = this.contents.map(function (item) {
          if (item.enabled === 1) {
            item.enabled = 'Ativo'
          } else {
            item.enabled = 'Inativo'
          }
          return item
        })
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar matérias, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editSubject (event) {
      this.$router.push({ name: 'materias.id', params: { id: event.id } })
    },
    openGenericFormDialog () {
      this.$dialog.custom(GenericFormDialog).with({ title: 'matéria' }).show()
        .then((subject) => {
          if (!subject) {
            return
          }
          this.newSubject(subject)
        })
    },
    async newSubject (data) {
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newSubject(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
